<div class="h-full w-full">
  <ejs-maps
    id="ht-container"
    style="display: block"
    [width]="mapWidth"
    [height]="mapHeight"
    [layers]="layers"
    (itemSelection)="itemSelection($event)"
  ></ejs-maps>
  
 <div class="absolute bottom-4 inset-x-0 mx-auto w-full px-8">
    <div class="flex justify-between text-[0.6rem] xl:text-[0.65rem] 2xl:text-[0.7rem] 3xl:text-[0.74rem] leading-none relative bottom-2">
      <span class="min-label">0%</span>
      <span class="max-label">100%</span>
    </div>
    <div class="gradient-bar w-full h-1.5 rounded-full mt-0.5">
      <div class="gradient-fill w-full h-full rounded-full"
           [style.background]="getGradientBackground()">
      </div>
    </div>
  </div>

</div>


<app-modal-inclusion-per-reg
*ngIf="isModalInclusioneActive"
[regionId]="regionId"
[regionName]="regionName"
[regionPercentage]="regionPercentage"
[countryId]="countryId"
[medicineId]="medicineId"
(closeModal)="showModalInclusione($event)"
></app-modal-inclusion-per-reg>
